/* eslint-disable */
import request from './helpers'

export function getAllStatementMenus () {
    return request ({
        url: '/api/v1/statement_menu/all',
        method: 'get'
    })
}

export function createStatementMenu (data) {
    return request ({
        url: '/api/v1/statement_menu/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function batchCreateStatementMenu (data) {
    return request ({
        url: '/api/v1/statement_menu/batch/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function editStatementMenu (id, data) {
    return request ({
        url: '/api/v1/statement_menu/edit/' + id,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteStatementMenu (id) {
    return request ({
        url: '/api/v1/statement_menu/delete/' + id,
        method: 'delete'
    })
}

export function getAllStatements () {
    return request ({
        url: '/api/v1/statement/all',
        method: 'get'
    })
}

export function createStatement (data) {
    return request ({
        url: '/api/v1/statement/create',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function editStatementPolicy (id, data) {
    return request ({
        url: '/api/v1/statement/edit/' + id,
        method: 'put',
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

export function deleteStatement (id) {
    return request ({
        url: '/api/v1/statement/delete/' + id,
        method: 'delete'
    })
}
